module.exports = __webpack_public_path__ + "img/logo.1c0a51f4.png";